(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  const prefetched = new Set();
  const allowedPath = /^(\/products\/|\/collections\/|\/pages\/|\/blogs\/|\/search)/;
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const canPrefetch =
    !connection || (!connection.saveData && !/2g/.test(connection.effectiveType || ''));

  function schedule(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout || 2200 });
      return;
    }

    window.setTimeout(callback, timeout || 900);
  }

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function prefetch(url, as) {
    if (!canPrefetch || prefetched.has(url)) return;
    prefetched.add(url);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = as || 'document';
    document.head.appendChild(link);
  }

  function prefetchLink(anchor) {
    const url = normalizeUrl(anchor && anchor.href);
    if (!url || url.origin !== window.location.origin || url.href === window.location.href) return;
    if (!allowedPath.test(url.pathname)) return;

    prefetch(url.href, 'document');
  }

  function onIntent(event) {
    if (!(event.target instanceof Element)) return;

    const anchor = event.target.closest('a[href]');
    if (!anchor) return;

    schedule(() => prefetchLink(anchor), 250);
  }

  function prefetchVisibleLinks() {
    if (!canPrefetch) return;

    const links = Array.from(document.querySelectorAll('a[href]'))
      .filter((link) => {
        const url = normalizeUrl(link.href);
        if (!url || url.origin !== window.location.origin || !allowedPath.test(url.pathname)) return false;

        const rect = link.getBoundingClientRect();
        return rect.top >= 0 && rect.top < window.innerHeight * 1.5;
      })
      .slice(0, 3);

    links.forEach((link) => prefetchLink(link));
  }

  function applyLazyImageHints(container) {
    const root = container instanceof Element ? container : document;
    const images = root.matches?.('img[loading="lazy"]')
      ? [root]
      : Array.from(root.querySelectorAll('img[loading="lazy"]'));

    images.forEach((image) => {
      if (!image.hasAttribute('decoding')) image.decoding = 'async';
      if (!image.hasAttribute('fetchpriority') && 'fetchPriority' in image) image.fetchPriority = 'low';
    });
  }

  function initLazyImageHints() {
    applyLazyImageHints(document);
  }

  document.addEventListener('mouseover', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, { capture: true });
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  document.addEventListener('shopify:section:load', (event) => applyLazyImageHints(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyImageHints, { once: true });
  } else {
    initLazyImageHints();
  }
  window.addEventListener('load', () => schedule(prefetchVisibleLinks, 2600), { once: true });
})();
